@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (timearrayfull && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <h3 style="margin-bottom: -38px" i18n>Day Sheet for</h3>
    <div style="float: left; margin-left: 180px;">
      <button pButton type="button" style="height: 50px; margin-right: 5px;width: 53px; float:left;" (click)="dateChange(-7);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-double-left" style="margin-right:8px;"></span>
      </button>
      <button pButton type="button" style="height: 50px; margin-right: 5px;width: 53px; float:left;" (click)="dateChange(-1);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-left" style="margin-right:8px;"></span>
      </button>
      <div style="float:left; width: 200px;">
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="chosenDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="dateSelected()" (onInput)="dateSelected()"></p-datepicker>
      </div>
      <button pButton type="button" style="height: 50px; margin-left: 5px;width: 53px; float:left;" (click)="dateChange(1);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-right" style="margin-right:8px;"></span>
      </button>
      <button pButton type="button" style="height: 50px; margin-left: 5px;width: 53px; float:left;" (click)="dateChange(7);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-double-right" style="margin-right:8px;"></span>
      </button>
      <button style="height: 50px; margin-left: 5px;float:left;" pButton pRipple type="button" class="p-button-sm p-element p-ripple p-button p-component" (click)="bookDateChosen(chosenDate)">
        <span class="pi pi-calendar" style="margin-right:8px;"></span>
        Book this Date
      </button>
    </div>
    <div #daysheetCard class="surface-card p-4 shadow-2 border-round" style="margin-top:20px;">
      <div style="width:100%;">
        @if (tabs.length == 0) {
          <p class="dsnotabs">Nothing is switched on for the Day Sheet. Choose what it shows on the <a routerLink="/daysheetresourceorder">Daysheet Resource Order</a> page.</p>
        }
        <!-- A tab per resource and resource group switched on on the Daysheet Resource Order page.
        A resource's tab is the capacity grid; a group's is the grouped view, marked with the
        group icon. -->
        <app-tabview (onChange)="applyResourceFilter()" [(activeIndex)]="selectedIndex" [scrollable]="true">
          @for (tab of tabs; track tab.key) {
            <app-tabpanel header="{{tab.name}}" [leftIcon]="tab.kind == 'GROUP' ? 'pi pi-sitemap' : null" [cache]="false">
              <!-- Supplied as a template so PrimeNG only creates the grid for the tab being
              looked at. Plain content is created in every tab and only hidden, which drew
              the whole grid once per resource - and gave every copy the same dsMainDiv id,
              so scrolling went to the first, hidden one. -->
              <ng-template pTemplate="content">
                @if (tab.kind == 'RESOURCE' && timeArray) {
                  <div id="dsMainDiv" style="overflow-x: hidden; overflow-y: auto; height: calc(100vh - 270px);" (scroll)="doScrollyStuff($event)">
                    <table class="" style="background-color:#eeeeee;width:100%;display: table;">
                      <tr>
                        <th style="background-color:#ffffff"><b>&nbsp;</b></th>
                        <th style="background-color:#ffffff; text-align: center;"><b>Used</b></th>
                        <th width="100%" style="background-color:#ffffff; padding:0;">
                          <table style="width:100%; table-layout:fixed;">
                            <colgroup>
                            @for (n of columnNumbers; track n) {
                              <col>
                              }
                            </colgroup>
                            <tr>
                              @for (n of columnNumbers; track n) {
                                <td style="text-align:center; padding:0; overflow:hidden;" [style.fontSize.px]="headerFontPx" [class.dscolnum--extra]="gridNormalCapacity > 0 && n > gridNormalCapacity"><b>{{n}}</b></td>
                              }
                            </tr>
                          </table>
                        </th>
                        <th style="background-color:#ffffff"><b>Rem</b></th>
                      </tr>
                      @for (row of (timeArray); track trackRow(ri, row); let ri = $index) {
                        <tr [class.dsnowrow]="ri === nowRowIndex" style="height:100%;">
                          @if (row[0].exceeded) {
                            <td width="3%" style="height:100%;background-color:#ffffff; font-weight:bold; color:red; text-align:center">{{row[0].time}}</td>
                          }
                          @if (!row[0].exceeded) {
                            <td width="3%" style="height:100%;background-color:#ffffff; text-align:center">{{row[0].time}}</td>
                          }
                          <td width="5%" style="height:100%;background-color:#ffffff; text-align:center; font-weight:bold">{{row[0].rowQty}}</td>
                          <td width="100%" class="dsblockscell" style="height:100%;">
                            @if (ri === nowRowIndex) {
                              <div class="dsnowline" [style.top.%]="nowPercent" [attr.data-now]="nowLabel"></div>
                            }
                            @if (timeRowClosings[ri]) {
                              <div class="dsclosed">
                                @if (timeRowClosings[ri].first) {
                                  <span class="dsclosed-label" pTooltip="{{timeRowClosings[ri].window.label}}" tooltipPosition="bottom">Closed: {{timeRowClosings[ri].window.label}}</span>
                                }
                              </div>
                            }
                            @if (timeRowAdjustments[ri]?.reduce > 0) {
                              <div class="dsadjusted" [style.width.%]="timeRowAdjustments[ri].coverPercent" [style.right.%]="timeRowAdjustments[ri].coverRightPercent">
                                @if (timeRowAdjustments[ri].first) {
                                  <span class="dsclosed-label" pTooltip="{{timeRowAdjustments[ri].text}}" tooltipPosition="bottom">{{timeRowAdjustments[ri].shortText}}</span>
                                }
                              </div>
                            }
                            <table style="width:100%; table-layout:fixed;">
                              <colgroup>
                              @for (n of columnNumbers; track n) {
                                <col>
                                }
                              </colgroup>
                              <tr>
                                @for (seg of timeArraySegments[ri]; track trackSegment($index, seg)) {
                                  <td [attr.colspan]="seg.span" style="padding:0;">
                                    <button class="dsblock"
                                      [class.stripes]="seg.cell.inprogress"
                                      [class.dsblock--closing]="seg.cell.closing"
                                      [class.dsblock--empty]="!seg.cell.bookingdata && !seg.cell.unavailable"
                                      [class.dsblock--extra]="!seg.cell.bookingdata && seg.cell.extra"
                                      [class.dsblock--unavailable]="!seg.cell.bookingdata && seg.cell.unavailable"
                                      [attr.title]="seg.cell.bookingdata ? null : (seg.cell.unavailable ? 'Not available at this time' : (seg.cell.extra ? 'Extra place - click to book this date' : 'Click to book this date'))"
                                      [class.dsblock--booked]="seg.cell.bookingdata"
                                      [style.backgroundColor]="seg.cell.bookingdata ? seg.cell.colour : null"
                                      (mouseenter)="hoverBookingData(seg.cell, $event)"
                                      (mouseleave)="clearHoverBookingData()"
                                      (click)="(seg.cell.bookingdata || !seg.cell.unavailable) && showBookingData(seg.cell, $event);">
                                      @if (seg.cell.bookingdata) {
                                        <span class="dsblocklabel" [style.color]="seg.textColour">
                                          <span class="dsbl-line dsbl-top">
                                            <b class="dsbl-name">{{seg.cell.customer?.lastName || seg.cell.customer?.fullName}}</b>
                                            <span class="dsbl-qty">(<i class="pi pi-user"></i>&nbsp;{{seg.cell.qty}})</span>
                                            <span class="dsbl-icons">
                                              @if (isArrived(seg.cell.bookingdata)) {
                                                <i class="pi pi-check-circle" pTooltip="Arrived"></i>
                                              }
                                              @if (hasAllergy(seg.cell.bookingdata)) {
                                                <i class="pi pi-exclamation-triangle" pTooltip="{{seg.cell.bookingdata.allergytext}}"></i>
                                              }
                                              @if (seg.cell.bookingdata.notes) {
                                                <i class="pi pi-file" pTooltip="{{seg.cell.bookingdata.notes}}"></i>
                                              }
                                            </span>
                                          </span>
                                          <span class="dsbl-line dsbl-pkg">{{seg.cell.bookingdata.packagename}}</span>
                                          <span class="dsbl-line dsbl-money">
                                            {{seg.cell.bookingdata.salesvalue | currency:(seg.cell.bookingdata.currency || CurrencySymbol)}}
                                            <span class="dsbl-due" [class.dsbl-due--owed]="seg.cell.bookingdata.outstanding > 0">O/S {{(seg.cell.bookingdata.outstanding || 0) | currency:(seg.cell.bookingdata.currency || CurrencySymbol)}}</span>
                                          </span>
                                        </span>
                                      }
                                      @if (isArrived(seg.cell.bookingdata)) {
                                        <span class="dsbl-arrivedbar"></span>
                                      }
                                      @if (seg.cell.bookingdata && seg.cell.bookingdata.outstanding > 0) {
                                        <span class="dsbl-osbar"></span>
                                      }
                                    </button>
                                  </td>
                                }
                              </tr>
                            </table>
                          </td>
                          <td style="background-color:#ffffff; text-align:center" width="5%">{{(row[0].effectiveMax ?? row[0].maxQty) - row[0].rowQty}}@if (timeRowAdjustments[ri]?.increase) {
                            <span class="dsadj-plus" pTooltip="{{timeRowAdjustments[ri].text}}" tooltipPosition="left">+{{timeRowAdjustments[ri].increaseBy}}</span>
                          }</td>
                        </tr>
                      }
                    </table>
                  </div>
                }
                <!-- Grouped view, for a resource group's tab. The group's resources against the same time
                rows under the group's heading, so the whole group reads across in one go. -->
                @if (tab.kind == 'GROUP') {
                  <div id="dsNormalDiv" style="overflow:auto; height: calc(100vh - 270px);" (scroll)="doScrollyStuff($event)">
                  <!-- The inside of a booking block, the same in both of the venue's Day Sheet block styles
                  and drawn as the capacity grid draws it: the same three lines, and the same arrived and
                  money-owed bars. -->
                  <ng-template #dsnBlockLabel let-b>
                    <span class="dsblocklabel" [style.color]="b.textColour">
                      <span class="dsbl-line dsbl-top">
                        <b class="dsbl-name">{{b.customer?.lastName || b.customer?.fullName}}</b>
                        <span class="dsbl-qty">(<i class="pi pi-user"></i>&nbsp;{{b.qty}})</span>
                        <span class="dsbl-icons">
                          @if (isArrived(b.bookingdata)) {
                            <i class="pi pi-check-circle" pTooltip="Arrived"></i>
                          }
                          @if (hasAllergy(b.bookingdata)) {
                            <i class="pi pi-exclamation-triangle" pTooltip="{{b.bookingdata.allergytext}}"></i>
                          }
                          @if (b.bookingdata.notes) {
                            <i class="pi pi-file" pTooltip="{{b.bookingdata.notes}}"></i>
                          }
                        </span>
                      </span>
                      <span class="dsbl-line dsbl-pkg">{{b.bookingdata.packagename}}</span>
                      <span class="dsbl-line dsbl-money">
                        {{b.bookingdata.salesvalue | currency:(b.bookingdata.currency || CurrencySymbol)}}
                        <span class="dsbl-due" [class.dsbl-due--owed]="b.bookingdata.outstanding > 0">O/S {{(b.bookingdata.outstanding || 0) | currency:(b.bookingdata.currency || CurrencySymbol)}}</span>
                      </span>
                    </span>
                    @if (isArrived(b.bookingdata)) {
                      <span class="dsbl-arrivedbar"></span>
                    }
                    @if (b.bookingdata.outstanding > 0) {
                      <span class="dsbl-osbar"></span>
                    }
                  </ng-template>
                    <table class="dsnormal" [class.dsnormal--blocks]="normalBlockMode">
                      <thead>
                        <!-- No groups on the sheet: one header row, as it always was. -->
                        @if (!normalHasGroups) {
                          <tr>
                            @for (nr of normalResources; track nr; let last = $last) {
                              <th class="dsn-start">Start</th>
                              <th class="dsn-head" colspan="2">{{nr.name}}@if (nr.max > 0) {
                                <span class="dsn-headmax"> ({{nr.max}})</span>
                              }</th>
                              @if (!last) {
                                <th class="dsn-gap"></th>
                              }
                            }
                          </tr>
                        }
                        <!-- With groups: the group headings across the top, and their resources' names
                        under them. A resource on its own takes both rows. -->
                        @if (normalHasGroups) {
                          <tr class="dsn-headrow1">
                            @for (nr of normalResources; track nr; let n = $index; let last = $last) {
                              @if (nr.groupId == null) {
                                <th class="dsn-start" rowspan="2">Start</th>
                                <th class="dsn-head" colspan="2" rowspan="2">{{nr.name}}@if (nr.max > 0) {
                                  <span class="dsn-headmax"> ({{nr.max}})</span>
                                }</th>
                                @if (!last) {
                                  <th class="dsn-gap" rowspan="2"></th>
                                }
                              }
                              @if (nr.groupFirst) {
                                <th class="dsn-grouphead" [attr.colspan]="1 + 2 * nr.groupSize"><div class="dsn-groupbar"><span class="dsn-grouptitle"><span class="pi pi-sitemap dsn-groupicon"></span>{{nr.groupName}}</span></div></th>
                                @if (nr.groupEndIndex < normalResources.length - 1) {
                                  <th class="dsn-gap" rowspan="2"></th>
                                }
                              }
                            }
                          </tr>
                        }
                        @if (normalHasGroups) {
                          <tr class="dsn-headrow2">
                            @for (nr of normalResources; track nr) {
                              @if (nr.groupId != null) {
                                @if (nr.groupFirst) {
                                  <th class="dsn-start dsn-memberhead dsn-group-left">Start</th>
                                }
                                <th class="dsn-head dsn-memberhead" colspan="2" [class.dsn-ingroup]="!nr.groupFirst" [class.dsn-group-right]="nr.groupLast">{{nr.name}}@if (nr.max > 0) {
                                  <span class="dsn-headmax"> ({{nr.max}})</span>
                                }</th>
                              }
                            }
                          </tr>
                        }
                      </thead>
                      <tbody>
                        @for (row of normalRows; track trackRow(ri, row); let ri = $index) {
                          <tr [class.dsnowrow]="ri === nowRowIndexNormal">
                            <!-- A cell with no span is a row covered by the slot above it: the resource is on a
                            longer interval than these rows, so it has nothing of its own to write here. -->
                            @for (cell of row.cells; track trackNormalCell(n, cell); let n = $index; let last = $last) {
                              <!-- A group's resources share one Start column, on the group's left. -->
                              @if (normalResources[n].groupFirst && cell.groupStart?.span > 0) {
                                <td class="dsn-start dsn-group-left dsn-groupstart" [attr.rowspan]="cell.groupStart.span" [class.dsn-start--now]="cell.groupStart.now">{{cell.groupStart.time}}</td>
                              }
                              @if (normalResources[n].groupId == null && cell.span > 0) {
                                <td class="dsn-start" [attr.rowspan]="cell.span" [class.dsn-start--exceeded]="cell.exceeded" [class.dsn-start--now]="cell.nowPercent != null">{{cell.time}}</td>
                              }
                              @if (cell.span > 0) {
                                <td class="dsn-cap" [class.dsn-ingroup]="normalResources[n].groupId != null && !normalResources[n].groupFirst" [attr.rowspan]="cell.span" [class.dsn-cap--part]="!cell.full && cell.used > 0" [class.dsn-cap--full]="cell.full" [class.dsn-cap--over]="cell.exceeded">{{cell.full ? (cell.exceeded ? 'OVER' : 'FULL') : cell.remaining}}@if (cell.adjustment?.increase) {
                                  <span class="dsadj-plus" pTooltip="{{cell.adjustment.text}}" tooltipPosition="right">+{{cell.adjustment.increaseBy}}</span>
                                }</td>
                              }
                              @if (cell.span > 0 && !normalBlockMode) {
                                <td class="dsn-cell" [class.dsn-group-right]="normalResources[n].groupLast" [attr.rowspan]="cell.span" [class.dsn-cell--increased]="cell.adjustment?.increase">
                                  @if (cell.nowPercent != null) {
                                    <div class="dsnowline" [style.top.%]="cell.nowPercent" [attr.data-now]="nowLabel"></div>
                                  }
                                  @if (cell.closedBy) {
                                    <div class="dsclosed">
                                      @if (cell.closedFirst) {
                                        <span class="dsclosed-label" pTooltip="{{cell.closedBy.label}}" tooltipPosition="bottom">Closed: {{cell.closedBy.label}}</span>
                                      }
                                    </div>
                                  }
                                  @if (cell.adjustment?.reduce > 0) {
                                    <div class="dsadjusted" [style.width.%]="cell.adjustment.coverPercent">
                                      @if (cell.adjustment.first) {
                                        <span class="dsclosed-label" pTooltip="{{cell.adjustment.text}}" tooltipPosition="bottom">{{cell.adjustment.shortText}}</span>
                                      }
                                    </div>
                                  }
                                  <!-- Slot style: each booking repeated in every slot it covers, one under another. -->
                                  @for (b of cell.bookings; track trackNormalBooking($index, b)) {
                                    <button class="dsblock dsblock--booked dsn-block"
                                      [class.stripes]="b.inprogress"
                                      [style.backgroundColor]="b.colour"
                                      (mouseenter)="hoverBookingData(b, $event)"
                                      (mouseleave)="clearHoverBookingData()"
                                      (click)="showBookingData(b, $event);">
                                      <ng-container *ngTemplateOutlet="dsnBlockLabel; context: { $implicit: b }"></ng-container>
                                    </button>
                                  }
                                  @if (cell.bookings.length == 0) {
                                    <button class="dsn-empty" title="Click to book this date" (click)="bookEmptySlot()"></button>
                                  }
                                </td>
                              }
                              <!-- Booking style: the resource's whole column is one cell, written on the first row, with
                              each booking drawn once as tall as it lasts - side by side where they overlap - and the
                              closings, reductions, increases and now line over it at their times. -->
                              @if (normalBlockMode && ri == 0) {
                                <td class="dsn-cell dsn-strip" [class.dsn-group-right]="normalResources[n].groupLast" [attr.rowspan]="normalRows.length">
                                  <button class="dsn-empty dsn-strip-empty" title="Click to book this date" (click)="bookEmptySlot()"></button>
                                  @for (mark of normalResources[n].marks; track $index) {
                                    @if (mark.kind == 'closed') {
                                      <div class="dsclosed dsn-strip-mark" [style.top.px]="mark.top" [style.height.px]="mark.height">
                                        @if (mark.label) {
                                          <span class="dsclosed-label" pTooltip="{{mark.label}}" tooltipPosition="bottom">Closed: {{mark.label}}</span>
                                        }
                                      </div>
                                    }
                                    @if (mark.kind == 'reduced') {
                                      <div class="dsadjusted dsn-strip-mark" [style.top.px]="mark.top" [style.height.px]="mark.height" [style.width.%]="mark.cover">
                                        @if (mark.label) {
                                          <span class="dsclosed-label" pTooltip="{{mark.text}}" tooltipPosition="bottom">{{mark.label}}</span>
                                        }
                                      </div>
                                    }
                                    @if (mark.kind == 'increased') {
                                      <div class="dsn-strip-increased" [style.top.px]="mark.top" [style.height.px]="mark.height"></div>
                                    }
                                  }
                                  @for (blk of normalResources[n].blocks; track blk.key) {
                                    @let b = blk.booking;
                                    <button class="dsblock dsblock--booked dsn-span"
                                      [style.top.px]="blk.top"
                                      [style.height.px]="blk.height"
                                      [style.left.%]="blk.left"
                                      [style.width.%]="blk.width"
                                      [class.stripes]="b.inprogress"
                                      [style.backgroundColor]="b.colour"
                                      (mouseenter)="hoverBookingData(b, $event)"
                                      (mouseleave)="clearHoverBookingData()"
                                      (click)="showBookingData(b, $event);">
                                      <ng-container *ngTemplateOutlet="dsnBlockLabel; context: { $implicit: b }"></ng-container>
                                    </button>
                                  }
                                  @if (normalResources[n].nowTop != null) {
                                    <div class="dsnowline" [style.top.px]="normalResources[n].nowTop" [attr.data-now]="nowLabel"></div>
                                  }
                                </td>
                              }
                              <!-- No gap between the resources of a group - they are drawn together, as one block. -->
                              @if (!last && cell.span > 0 && (normalResources[n].groupId == null || normalResources[n].groupLast)) {
                                <td class="dsn-gap" [attr.rowspan]="cell.span"></td>
                              }
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </ng-template>
            </app-tabpanel>
          }
        </app-tabview>
      </div>
      <div>
        <!--<div class="surface-card p-4 shadow-2 border-round" style="width: 24%;float: left;margin-left: 13px;margin-top: 56px;margin-right: -88px;height: 33%;overflow-y: scroll;">
        <span class="p-input-icon-left ml-auto" style="margin-right:20px;width:100% ">
          <div style="margin-bottom:10px;"><b>Time Selected: {{chosenTime}}</b></div>
          <i class="pi pi-search" style="margin-top: 10px;"></i>
          <input pInputText type="text" (input)="daysheetTable.filterGlobal($event.target.value, 'contains')" style="height: 29px;padding-left:33px; width:100%;" />
        </span>
        <div>
          <p-table  #daysheetTable
            [value]="" sortField="name"
            [globalFilterFields]="['name', 'bookingIdHR']"
            responsiveLayout="scroll">
            <ng-template pTemplate="header">
            </ng-template>
            <ng-template pTemplate="body" let-data>
              <tr (click)="viewData(data.bookingId)" style="cursor:pointer">
                <td *ngIf="data.notes != '' && data.notes != null" width="30px;">
                  <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                </td>
                <td *ngIf="data.notes == '' || data.notes == null" width="30px;">
                  <span style="color:#dfdfdf" class="pi pi-exclamation-circle"></span>
                </td>
                <td style="padding: 10px 0px 10px 0px; font-size:14px;" width="60%">
                  {{data.bookingIdHR}}
                </td>
                <td style="padding: 10px 0px 10px 0px; font-size:14px;" width="60%">
                  {{data.customer.fullName}}
                </td>
                <td style="padding: 10px 0px 10px 0px; font-size:14px;" width="15%">
                  {{data.bookingdata.numofpeople}}
                </td>
                <td *ngIf="data.bookingdata.outstanding > 0" style="padding: 10px 0px 10px 0px; font-size:14px;"  width="5%" >
                  <b style="color:red;">{{data.outstanding | currency:(data.bookingdata.currency || CurrencySymbol)}}</b>
                </td>
                <td *ngIf="data.bookingdata.outstanding <= 0" style="padding: 10px 0px 10px 0px; text-align:right; font-size:14px;"  width="5%" >
                  {{data.outstanding | currency:(data.bookingdata.currency || CurrencySymbol)}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>-->
      @if (bookingFromClick) {
        <div class="dssummary" [class.dssummary--left]="summaryOnLeft">
          <div>
            <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:10px;">
              <p style="font-weight:bold; margin:0;">Summary</p>
              <button pButton type="button" class="p-button-sm p-button-text p-button-secondary" style="width:30px; height:30px; padding:0;" pTooltip="Close" (click)="closeSummary()">
                <span class="pi pi-times"></span>
              </button>
            </div>
            @if (!summaryPinned) {
              <div style="font-size:12px; color:#6c757d; margin-bottom:10px;">Click the block to keep this open.</div>
            }
            <div>
              @if (!bookingFromClick.inprogress) {
                <button style="margin-top: -6px !important; width: 100% !important; margin-bottom: 20px;" pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="editData(bookingFromClick.bookingdata.bookingid);">
                  <span class="pi pi-pencil" style="margin-right:8px;"></span>
                  Edit this booking
                </button>
              }
              @if (useCounters && !bookingFromClick.inprogress && !isArrived(bookingFromClick.bookingdata)) {
                <button style="width: 100% !important; margin-bottom: 20px;" pButton pRipple type="button" class="p-button p-element p-button-warn w-auto" (click)="admitAllForBooking(bookingFromClick.bookingdata.bookingid);">
                  <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                  Admit All
                </button>
              }
              @if (useCounters && !bookingFromClick.inprogress && isArrived(bookingFromClick.bookingdata)) {
                <button style="width: 100% !important; margin-bottom: 20px;" pButton pRipple type="button" class="p-button p-element p-button-secondary w-auto" (click)="leaveAllForBooking(bookingFromClick.bookingdata.bookingid);">
                  <span class="pi pi-sign-out" style="margin-right:8px;"></span>
                  Leave All
                </button>
              }
              @if (bookingFromClick.inprogress) {
                <div style="width:100%; text-align:center; background-color:red;border-radius:5px;color:white;height: 45px;margin-bottom: 30px;">
                  <div style="padding-top: 10px;font-weight:bold;">This booking is in Progress</div>
                </div>
              }
              @if (bookingFromClick.customer) {
                <div>
                  <div style="width:100%; margin-bottom: 15px;">
                    <span class="pi pi-user" style="margin-right: 10px;"></span><b>Customer</b> : {{bookingFromClick.customer.fullName != null ? bookingFromClick.customer.fullName + " " + bookingFromClick.customer.address1 + ", " + bookingFromClick.customer.address2 + ", " + bookingFromClick.customer.townCity + ", " + bookingFromClick.customer.postCode : ""}}
                  </div>
                </div>
              }
              @if (bookingFromClick.bookingdata.outstanding) {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Outstanding</b> : <span style="color: red; font-weight: bold;">{{bookingFromClick.bookingdata.outstanding | currency:(bookingFromClick.bookingdata.currency || CurrencySymbol)}}</span>
                  <button pButton type="button" style="height: 25px; margin-right: 5px;width: 25px; float:right;" class="p-button-sm p-element p-ripple p-button p-component" (click)="editbookingpayoff(bookingFromClick.bookingdata.bookingid)">
                    <span class="pi pi-pound" style="margin-left: -8px; font-size: 15px;"></span>
                  </button>
                </div>
              }
              @if (bookingFromClick.bookingdata.outstanding <= 0) {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Outstanding</b> : {{bookingFromClick.bookingdata.outstanding | currency:(bookingFromClick.bookingdata.currency || CurrencySymbol)}}
                </div>
              }
              <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-users" style="margin-right: 10px;"></span><b>Admissions</b> : {{bookingFromClick.bookingdata.admissions}}
                <button pButton type="button" style="height: 25px; margin-right: 5px;width: 25px; float:right;" class="p-button-sm p-element p-ripple p-button p-component">
                  <span class="pi pi-users" style="margin-left: -8px; font-size: 15px;" (click)="editbookingadmissions(bookingFromClick.bookingdata.bookingid)"></span>
                </button>
              </div>
              <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Start Date/Time</b> : {{bookingFromClick.bookingdata.bookingstart | date:'HH:mm' : 'UTC'}}
              </div>
              <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-box" style="margin-right: 10px;"></span><b>Package</b> : {{bookingFromClick.bookingdata.packagename}}
              </div>
              @if (bookingFromClick.upgradetext != '') {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-arrow-up" style="margin-right: 10px;"></span><b>Upgrade</b> : {{bookingFromClick.bookingdata.upgradetext}}
                </div>
              }
              @if (bookingFromClick.addontext != '') {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-arrow-circle-up" style="margin-right: 10px;"></span><b>Add-Ons</b> : {{bookingFromClick.bookingdata.addontext}}
                </div>
              }
              @if (bookingFromClick.bookingdata.extras != '') {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-star" style="margin-right: 10px;"></span><b>Extras</b> : {{bookingFromClick.bookingdata.extras}}
                </div>
              }
              <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Sales ID</b> : {{bookingFromClick.bookingdata.humanreadableid}}
              </div>
              <!--
              <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>End Date/Time</b> : {{bookingFromClick.bookingdata.bookingend| date:'HH:mm' : 'UTC'}}
              </div>
              <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Arrival Date/Time</b> : {{bookingFromClick.bookingdata.arrival| date:'HH:mm' : 'UTC'}}
              </div> -->
              <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Sales Value</b> : {{bookingFromClick.bookingdata.salesvalue | currency:(bookingFromClick.bookingdata.currency || CurrencySymbol)}}
              </div>
              @if (bookingFromClick.bookingdata.totaldiscount > 0) {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Discounts</b> : {{bookingFromClick.bookingdata.discounts | currency:(bookingFromClick.bookingdata.currency || CurrencySymbol)}}
                </div>
              }
              @if (bookingFromClick.bookingdata.bookingfee > 0) {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Booking Fee</b> : {{bookingFromClick.bookingdata.bookingfee | currency:(bookingFromClick.bookingdata.currency || CurrencySymbol)}}
                </div>
              }
              @if (bookingFromClick.bookingdata.outstanding) {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Paid</b> : <span>{{bookingFromClick.bookingdata.paid | currency:(bookingFromClick.bookingdata.currency || CurrencySymbol)}}</span>
                </div>
              }
              @if (bookingFromClick.bookingdata.outstanding <= 0) {
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Paid</b> : {{bookingFromClick.bookingdata.paid | currency:(bookingFromClick.bookingdata.currency || CurrencySymbol)}}
                </div>
              }
              <!-- <div style="width:100%; margin-bottom: 15px;">
              <span class="pi pi-list" style="margin-right: 10px;"></span><b>Itinerary</b> : {{bookingFromClick.bookingdata.itinerary}}
            </div> -->
            <div style="width:100%; margin-bottom: 15px;">
              <span class="pi pi-list" style="margin-right: 10px;"></span><b>Itinerary</b>:
              <div style="margin-top:5px; margin-bottom:10px;">
                <table [cellPadding]="3" >
                  <tr style="border-bottom: 1px solid #dddddd">
                    <td style="width:5%">&nbsp;</td>
                    <td style="width:50%">
                      <b>Arrival:</b>
                    </td>
                    <td style="width:20%">
                      {{bookingFromClick.bookingdata.arrival| date: 'HH:mm' : 'UTC'}}
                    </td >
                    <td style="width:20%">&nbsp;</td>
                  </tr>
                  @for (itin of (bookingFromClick.bookingdata.itineraryEX); track itin) {
                    <tr style="border-bottom: 1px solid #dddddd">
                      <td>&nbsp;</td>
                      <td>
                        <b>{{itin.resource}}</b>
                      </td>
                      <td>
                        {{itin.starttime}}
                      </td>
                      <td >
                        {{itin.people}}&nbsp;people
                      </td>
                    </tr>
                  }
                  <tr style="border-bottom: 1px solid #dddddd">
                    <td>&nbsp;</td>
                    <td>
                      <b>End:</b>
                    </td>
                    <td>
                      {{addMs(bookingFromClick.bookingdata.bookingend, 1)| date:'HH:mm' : 'UTC'}}
                    </td>
                    <td>&nbsp;</td>
                  </tr>
                </table>
              </div>
            </div>
            @if (bookingFromClick.customer) {
              <div>
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-envelope" style="margin-right: 10px;"></span><b>Email</b> : {{bookingFromClick.customer.email != null ? bookingFromClick.customer.email : ""}}
                </div>
                <div style="width:100%; margin-bottom: 15px;">
                  <span class="pi pi-mobile" style="margin-right: 10px;"></span><b>Mobile</b> : {{bookingFromClick.customer.mobile != null ? bookingFromClick.customer.mobile : ""}}
                </div>
              </div>
            }
            <div style="width:100%; margin-bottom: 15px;">
              <span class="pi pi-file" style="margin-right: 10px;"></span><b>Notes</b> : {{bookingFromClick.bookingdata.notes}}
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
<!-- Closes the outer div, which was left open (Angular closed it implicitly here) -->
</div>
}
